import { fromJS } from 'immutable';
import { ActionCreator, Action } from 'redux';
import * as Axios from "axios";

const configInitialState = fromJS({ serviceUrl: null });

export interface AppConfig {
    serviceUrl: string,
    scopes: string,
    clientId: string,
    identityServerUrl: string,
    passthrough: any,
    aiInstrumentationKey: string,
    aiRoleName: string,
    timeSheet: any
}

export interface ApplicationState {
    router: any,
    config: AppConfig,
    timeSheet: any,
    employee: any,
    taskTemplate: any
}

interface AppInitialized extends Action {
    type: '@@app/INITIALIZED';
    payload: {
        config: AppConfig
    };
}

interface AppThunkAction<TAction> {
    (dispatch: (action: TAction) => void, getState: () => ApplicationState): void;
}

export const initialize: ActionCreator<AppThunkAction<AppInitialized>> = () => (dispatch, getState) => {
    return async () => {
        const http = Axios.default.create({
            timeout: 30000,
        });
        const result = await http.get("api/v1/config");

        dispatch({
            type: '@@app/INITIALIZED',
            payload: {
                config: result.data,
            },
        });
    }
}

export function configReducer(state = configInitialState, action: any) {
    switch (action.type) {
        case '@@app/INITIALIZED':
            return {
                ...state,
                serviceUrl: action.payload.config.serviceUrl,
                identityServerUrl: action.payload.config.identityServerUrl,
                clientId: action.payload.config.clientId,
                passthrough: action.payload.config.passthrough,
                scopes: action.payload.config.scopes,
                aiInstrumentationKey: action.payload.config.aiInstrumentationKey,
                aiRoleName: action.payload.config.aiRoleName,
            };
        default:
            return state;
    }
}